// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3hFAZ","title":"InfoRow_title__1EGLH"};